import CatalogSearchFilter from '../catalog-search-filter/catalog-search-filter';
import CatalogTable from '../catalog-table/catalog-table';
import GroupActions from '../group-actions/group-actions';
import AddOffer from '../add-offer/add-offer';
import Validation from '../../../common/assets/js/validation';
import Helpers from '../helpers/helpers';

export default new class ModalBindings {
    constructor() {
        /* ClassName */
        this.modalOpened = 'modal_opened';
        this.modalBox = 'modal__box';
        this.modal = 'modal';
        this.modalOpenAnimationSpeed = 500;

        this.$popupTextContainer = $('.js-popupContent');
        this.$popupTitle = $('.js-popupTitle');

        this.$modal = $('.modal');
        this.$modalBox = $('.modal__box');

        this.bindEvents();
    }

    bindEvents() {
        $(document).on('click', '.js-modal-open', (e) => {
            e.preventDefault();   

            let targetDataValue = $(e.target).attr('data-modal-link') ? $(e.target).attr('data-modal-link') : $(e.target).closest('.js-modal-open').attr('data-modal-link'),
                currentModal = $(`.${this.modal}[data-modal='${targetDataValue}']`);

            this.openModal(currentModal);
        });

        $(document).on('click', '.js-backArrow', (e) => {
            e.preventDefault();

            let $arrowBack = $(e.target);
            $arrowBack.closest('[data-modal]').find('.button-modal-close').trigger('click');
        });

        this.$modal.on('click', (e) => {
            let currentElement = $(e.target);

            if (currentElement.closest(`.${this.modalBox}`).length && !currentElement.hasClass('button-modal-close') && !currentElement.hasClass('js-closeModal')) return;
            this.hideModal();
        });
        $(document).keyup((e) => {
            if(e.keyCode === 27) {
                this.hideModal();
            }
        });
    }

    getOpenedModal() {
        let latestTimeStamp,
            $lastOpenedModal,
            lastOpenedModalIndex,
            openedModalsArr = $(`.${this.modal}.${this.modalOpened }`),
            timeStampsArr = [];

        // if there is one opened modal - returns it, as last opened
        if (openedModalsArr.length === 1) {
            $lastOpenedModal = $(openedModalsArr[0]);
            return $lastOpenedModal;
            // if there is more than one opened modal
        } else {
            //gets all opened modal timestamps
            for (let i = 0; i < openedModalsArr.length; i++) {
                timeStampsArr.push(parseInt($(openedModalsArr[i]).attr('data-time-stamp')));
            }

            //finds last opened modal by its timeStamp
            latestTimeStamp = timeStampsArr.max();
            lastOpenedModalIndex = timeStampsArr.indexOf(latestTimeStamp);
            $lastOpenedModal = $(openedModalsArr[lastOpenedModalIndex]);
        }

        return $lastOpenedModal;
    }

    openModal(modal) {
        let $html = $('html');

        this.currentModalName = modal.attr('data-modal');
        this.toggleScrollBody(true);
        this.appendTextToPopup();

        modal.fadeIn(this.modalOpenAnimationSpeed, function () {
            $html.attr('data-scroll', $html.scrollTop());
        });

        modal.addClass(this.modalOpened);
        modal.attr('data-time-stamp', (new Date).getTime());

        return false;
    }

    appendTextToPopup() {
        let textForPopup = $('.js-popupText').attr('data-popup-text');

        if (textForPopup && textForPopup.length && !this.$popupTextContainer.text() && !this.$popupTextContainer.text().length) {
            this.$popupTextContainer.text(textForPopup);
        }
    }

    appendLayoutToPopup(data) {
        this.$popupTextContainer.text('');
        this.$popupTextContainer.append(data.modelList);
    }

    changeTitleInPopup(data) {
        this.$popupTitle.empty();
        this.$popupTitle.append(data.modalTitle);
    }

    hideModal(params) {
        let $openedModal = this.getOpenedModal();

        if ($openedModal.hasClass(this.modalOpened)) {
            this.toggleScrollBody(false);
            $openedModal.fadeOut(this.modalOpenAnimationSpeed, () => {
                $openedModal.removeClass(this.modalOpened);
            });
            this.doSomeOnCloseModal($(this.$modal), params);
        }
    }

    doSomeOnCloseModal($modal, params) {
        switch(this.currentModalName) {
            case 'categories':
                CatalogSearchFilter.makeCategoriesChecked();
                break;

            case 'unpublish-offer-modal': 
                if (!params || (params && !params.dontSetOldValue)) {
                    CatalogTable.setOldValueInInput();
                }
                break;

            case 'add-comments':
                GroupActions.clearTextField();
                break;

            case 'add-offer':
                Validation.removeErrors($modal.find('form'));
                AddOffer.clearFields();
                break;

            default:
                break;
        }
    }

    toggleScrollBody(isFixBody) {
        let $body = $('body'),
            $html = $('html'),
            hideScrollClassName = 'body_hide-scroll',
            scrollWidth =  window.innerWidth - document.documentElement.clientWidth;

        if (isFixBody) {
            $body.hasClass(hideScrollClassName) ? '' : $body.addClass(hideScrollClassName);

            if (Helpers.isMobile()) {
                $body.css({'overflow':'hidden'});
                $html.css({'position':'fixed'});
                $body.css({'position': 'fixed'});
            }
        } else {
            $body.removeClass(hideScrollClassName);

            if (Helpers.isMobile()) {
                $html.css({'position': 'static'});
                $body.css({'overflow': 'auto'});
                $body.css({'position': 'static'});
            }
        }

        $body.css('padding-right',scrollWidth);
    }
};


// WEBPACK FOOTER //
// ./src/common/modules/modal/ModalBindings.js